import type { ColorToken } from '../../util/theme/fluent9';
import type { FlexProps } from '../Flex';

import type { AppLayoutContextProviderProps } from './AppLayoutContextProvider.types';

export interface AppLayoutProps {
  /**
   * If true will add overflow: hidden to the body/document elements to disable scrolling.
   * This gives the page a rigid layout and allows individual sections of the layout to
   * manage their own scrolling (nav column, main content column of content + sidebar).
   */
  readonly disableNativePageScroll?: boolean;

  /**
   * Optional height value, useful in layouts where the app does not take up the entire
   * page area like Outlook and SharePoint.
   * @defaultValue '100vh'
   */
  readonly height?: FlexProps['height'];

  /**
   * Optional background color for the entire page.
   */
  readonly backgroundColor?: ColorToken;

  readonly closeContentSidebarAriaLabel: AppLayoutContextProviderProps['closeContentSidebarAriaLabel'];
  readonly openContentSidebarAriaLabel: AppLayoutContextProviderProps['openContentSidebarAriaLabel'];
  readonly hasBackButton?: AppLayoutContextProviderProps['hasBackButton'];
  readonly hasOuterLeftNav?: AppLayoutContextProviderProps['hasOuterLeftNav'];
  readonly removeContentPadding?: AppLayoutContextProviderProps['removeContentPadding'];
  readonly pinnedCollapsibleRightRail?: AppLayoutContextProviderProps['pinnedCollapsibleRightRail'];
  readonly unifiedSidebar?: AppLayoutContextProviderProps['unifiedSidebar'];
}

/*
 * Used as that aria-labelledby for the main content area. The primary heading for the main content
 * area should have this as its id.
 */
export const mainContentAreaAriaLabelId = 'mainLabel';
